/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';
import {Droppable, Draggable} from 'react-beautiful-dnd';
import TableItems from "./TableItems";
import {PERMISSIONS} from "../../../../../constants/constants";


export default class TableBody extends Component {

    render() {

        const { resources } = this.props;
        const arrayLength = resources.resourceData.length;

        return (
            <Droppable droppableId={this.props.listId}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}>
                        {resources.resourceData.map((resourceIn, index) => (
                            <Draggable
                                key={resourceIn.resourceInstanceId}
                                draggableId={resourceIn.resourceInstanceId}
                                index={index} isDragDisabled={this.props.permissions.includes(PERMISSIONS.view_only_draggable)}>
                                {(provided, dragSnapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}>

                                        <TableItems
                                            index={index}
                                            key={resourceIn.resourceInstanceId}
                                            resourceIn={resourceIn}
                                            isDragging={dragSnapshot.isDragging}
                                            provided={provided}
                                            resourceData = {this.props.resourcesData}
                                            collectionId = {this.props.collectionId}
                                            chapterId={this.props.chapterId}
                                            loadCollection = {this.props.loadCollection}
                                            length = {arrayLength}
                                            activeCollection = {this.props.activeCollection}
                                            freezeUi = {this.props.freezeUi}
                                            permissions = {this.props.permissions}

                                        />
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>

        );
    }

}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterComponents/HelperMethods/TableBody.js